var React = require('react');

function Pause (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M28.5 0C44.266 0 57 12.734 57 28.5C57 44.266 44.266 57 28.5 57C12.734 57 0 44.266 0 28.5C0 12.734 12.734 0 28.5 0ZM17.8277 14.3106H24.983V42.6894H17.8277V14.3106ZM32.017 14.3106H39.1723V42.6894H32.017V14.3106Z","fill":"#EDCF30"}));
}

Pause.defaultProps = {"width":"57","height":"57","viewBox":"0 0 57 57","fill":"none"};

module.exports = Pause;

Pause.default = Pause;
